export default __webpack_public_path__ + "static/media/announcement-icon.859a2773.svg";